import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import axios from 'src/utils/axios';
import {
  Grid,
  Button,
  Snackbar,
  Typography,
  MenuItem,
  Tooltip,
  IconButton,
  Box,
  Select,
  InputLabel,
  FormControl ,
  Backdrop,
  CircularProgress
} from '@material-ui/core';
import Card from '@mui/material/Card';
import { CardContent } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import Alert from 'src/components/Alert';
import { confirmAlert } from 'react-confirm-alert';
import { TextField } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Segoe UI',
    width: '100%',
    height: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFA500'
  },
  card: {
    width: '100%',
    height: '100%'
  },
  tableHeadCell: {
    border: '1px solid #ddd',
    color: '#fff',
    backgroundColor: '#0033a0'
  },
  tableCell: {
    textAlign: 'center',
    borderRight: '1px solid #00000050',
    borderBottom: '1px solid #00000050'
  },
  coloredText: {
    textAlign: 'center'
  },
  InputGrid: {
    border: '1px solid #ccc'
  },
  Box: {
    backgroundColor: '#0033a0'
  },
  sortHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  icon: {
    color: 'white',
    fontSize: '1rem',
    cursor: 'pointer'
  },
  tableHead: {
    overflowWrap: 'break-word'
  }
}));

function SarisDynamicOther() {
  const classes = useStyles();
  const history = useHistory();
  const [dynamicTypes,setDynamicTypes] = React.useState([]);
  const [dynamicOtherGeneralData,setDynamicOtherGeneralData] = React.useState([]);
  const [definitionCode, setDefinitionCode] = React.useState([]);
  const [
    definitionCodeDescription,
    setDefinitionCodeDescription
  ] = React.useState([]);
  const [type, setType] = React.useState(6);

  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    getDynamicTypes();
    getDynamicOtherData();
  }, []);

  const getDynamicOtherData = () => {
    setLoading(true);
    axios.get('/GetDynamicOther').then(response => {
      const data = response.data;
      setDynamicOtherGeneralData(data);
      setLoading(false);
    });
  };

   const getDynamicTypes = () => {
    setLoading(true);
    axios.get('/GetDynamicTypes').then(response => {
      const data = response.data;
      setDynamicTypes(data);
      setLoading(false);
    });
  };

  const handleDeleteSelectedRow = (ElCode, ElType) => {
    confirmAlert({
      message: 'Seçilen satırı silmek istediğinize emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            deleteSelectedRows(ElCode, ElType);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const deleteSelectedRows = (ElCode, ElType) => {
    const data = {
      ElCode: ElCode,
      ElType: ElType
    };
    setLoading(true);

    axios
      .post('/SetSarisDynamicServiceLaborMaterialDelete', data, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => {
        if (response.data.ErrorCode == 0) {
          setresponseMessage('Silme İşlemi başarıyla gerçekleşmiştir.');
          setUyariTip('success');
          getDynamicOtherData();
        } else {
          setresponseMessage(response.data.ErrorDescription);
          setUyariTip('error');
        }
        setLoading(false);
        setUyari(true);
      });
  };

  const handleCreateNewServiceLaborMaterial = () => {
    const data = {
      KulElCode: definitionCode,
      ElType: type,
      Description: definitionCodeDescription
    };
    setLoading(true);
    axios
      .post('/SetSarisDynamicCreateNewServiceLaborMaterial', data, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => {
        if (response.data.ErrorCode == 0) {
          setresponseMessage('Ekleme İşlemi başarıyla gerçekleşmiştir.');
          setUyariTip('success');
          getDynamicOtherData();
        } else {
          setresponseMessage(response.data.ErrorDescription);
          setUyariTip('error');
        }
        setLoading(false);
        setUyari(true);
      });
    setLoading(false);

    //Temizleme İşlemi
    setDefinitionCode([]);
    setDefinitionCodeDescription([]);
    setType([]);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleRouteDetailPage = (
    UserCode,
    ElType,
    ElCode,
    UserElCode,
    Description
  ) => {
    history.push(
      `/SarisDesc/OtherDynamicDetaill/${UserCode}/${ElType}/${ElCode}/${UserElCode}/${Description}`
    );
  };

  const columns = [
    {
      field: 'KUL_EL1_KODU',
      headerName: 'Kod',
      width: 300,
      headerAlign: 'center',
      align: 'center',
      renderCell: params => (
        <span
          style={{
            textDecoration: 'underline',
            cursor: 'pointer',
            color: '#FF9800'
          }}
          onClick={() => {
            handleRouteDetailPage(
              params.row.KUL_KODU,
              params.row.EL1_TIP_KODU,
              params.row.EL1_KODU,
              params.row.KUL_EL1_KODU,
              params.row.ACIKLAMA
            );
          }}
        >
          {params.row.KUL_EL1_KODU}
        </span>
      )
    },
    {
      field: 'ACIKLAMA',
      headerName: 'Açıklama',
      width: 600,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'EL1_TIPI',
      headerName: 'Tip',
      width: 350,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'KULLANICI',
      headerName: 'Kullanıcı',
      width: 300,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'TARIH',
      headerName: 'Oluşturulma Tarihi',
      width: 400,
      headerAlign: 'center',
      align: 'center',
      sortComparator: (v1, v2) => {
        const date1 = new Date(v1).getTime();
        const date2 = new Date(v2).getTime();
        return date1 - date2;
      },
      renderCell: params => {
        return params.value
          ? moment(params.value).format('DD/MM/YYYY HH:mm:ss')
          : 'Geçerli Tarih Yok';
      }
    },
    {
      field: 'Sil',
      headerAlign: 'center',
      align: 'center',
      renderCell: cellValues => {
        return (
          <Box sx={{ justifyContent: 'center', '& > :not(style)': { m: 1 } }}>
            <Tooltip title="sil">
              <IconButton>
                <DeleteIcon
                  style={{ color: '#FF9800' }}
                  onClick={() =>
                    handleDeleteSelectedRow(
                      cellValues?.row?.EL1_KODU,
                      cellValues?.row?.EL1_TIP_KODU
                    )
                  }
                />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
      width: 100
    }
  ];

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Backdrop className={classes.backdrop} open={loading}>
              <CircularProgress color="inherit" />
      </Backdrop>
      <Card className={classes.card}>
        <CardContent>
          <Grid container spacing={5}>
             <Grid item xs={12}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    style={{
                      color: '#FF9800',
                      textAlign: 'center'
                    }}
                  >
                    <b>Diğer Dinamik Tanımlar</b>
                  </Typography>
                </Grid>
            <Grid item xs={12} sm={12} md={3} lg={4} />
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid container spacing={1} className={classes.InputGrid}>
                <Grid item xs={12}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    style={{
                      color: '#FF9800',
                      textAlign: 'center'
                    }}
                  >
                    Yeni Giriş
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Tanım Kodu"
                    fullWidth
                    variant="outlined"
                    disabled={true}
                    size="medium"
                    sx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)'
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 0, 0, 0.23)'
                      },
                      '& .MuiInputLabel-root.Mui-disabled': {
                        color: 'rgba(0, 0, 0, 0.87)'
                      },
                      '& .MuiInputLabel-shrink.Mui-disabled': {
                        color: 'rgba(0, 0, 0, 0.87)'
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    label="Tanım Kodu"
                    fullWidth
                    variant="outlined"
                    size="medium"
                    InputLabelProps={{ shrink: true }}
                    value={definitionCode}
                    onChange={e => {
                      setDefinitionCode(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Grup Tipi"
                    fullWidth
                    variant="outlined"
                    disabled={true}
                    size="medium"
                    sx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)'
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 0, 0, 0.23)'
                      },
                      '& .MuiInputLabel-root.Mui-disabled': {
                        color: 'rgba(0, 0, 0, 0.87)'
                      },
                      '& .MuiInputLabel-shrink.Mui-disabled': {
                        color: 'rgba(0, 0, 0, 0.87)'
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={8}>
                <FormControl fullWidth>
                  <InputLabel id="GrupTipi">Grup Tipi</InputLabel>
                  <Select
                    labelId="GrupTipi"
                    variant="outlined"
                    value={type}
                    InputLabelProps={{ shrink: true }}
                    select
                    onChange={e => setType(e.target.value)}
                    fullWidth
                    size="medium"
                  >
                    {dynamicTypes? dynamicTypes.map(item => <MenuItem value={item.EL1_TIPI}>{item.ACIKLAMA}</MenuItem>):<></>}
                  </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Tanım Açıklaması"
                    fullWidth
                    variant="outlined"
                    disabled={true}
                    size="medium"
                    sx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)'
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 0, 0, 0.23)'
                      },
                      '& .MuiInputLabel-root.Mui-disabled': {
                        color: 'rgba(0, 0, 0, 0.87)'
                      },
                      '& .MuiInputLabel-shrink.Mui-disabled': {
                        color: 'rgba(0, 0, 0, 0.87)'
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    label="Tanım Açıklaması"
                    fullWidth
                    variant="outlined"
                    size="medium"
                    InputLabelProps={{ shrink: true }}
                    value={definitionCodeDescription}
                    onChange={e => {
                      setDefinitionCodeDescription(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={4} />
                <Grid item xs={4}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="medium"
                    onClick={() => {
                      handleCreateNewServiceLaborMaterial();
                    }}
                  >
                    EKLE
                  </Button>
                </Grid>
                <Grid item xs={4} />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={4} />
            <Grid item xs={12}>
              <DataGrid
                rows={dynamicOtherGeneralData || []}
                columns={columns}
                getRowId={rows => rows.EL1_KODU}
                style={{
                  height: 600,
                  width: '100%',
                  textAlign: 'center',
                  justifyItems: 'center'
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}

export default SarisDynamicOther;
